import { PAGE_SLUG } from 'mk/autogenerated/translations/urls.2f99b3c69c1be98699aa952488768c7a'

const filterParams = `:category([a-z\\d_-]+)?/:filters([\\w-]+)?/:page(${PAGE_SLUG}-\\d+)?/`;

const bazaarPrefix = '/market/';
export const bazaarSellerSearchUrl = `${bazaarPrefix}seller/search/`;
const bazaarSellerUrl = `${bazaarPrefix}seller/:username([0-9a-z_\\.\\-]+)/`;
export const bazaarSellerBazaarUrl = `${bazaarSellerUrl}v3/${filterParams}`;
export const bazaarSellerReviewsFromBuyersUrl = `${bazaarSellerUrl}reviews/`;
export const bazaarSellerReviewsFromSellersUrl = `${bazaarSellerUrl}reviews-from-sellers/`;
const bazaarMyUrl = `${bazaarPrefix}my_bazaar/:username([0-9a-z_\\.\\-]+)/`;
export const bazaarMyBazaarUrl = `${bazaarMyUrl}v3/${filterParams}`;
export const bazaarMyReviewsFromBuyersUrl = `${bazaarMyUrl}reviews/`;
export const bazaarMyReviewsFromSellersUrl = `${bazaarMyUrl}reviews-from-sellers/`;
export const bazaarMyWidgetUrl = `${bazaarMyUrl}widget/`;
export const bazaarMyTransactionsUrl = `${bazaarMyUrl}buyers/`;
export const bazaarProductDetailUrl = `${bazaarPrefix}:category([a-z\\d_\\-]+)/:hash([0-9a-z]+)/:title([0-9a-z\\d_\\-]+)/v3/`;
